<script setup lang="ts">
import { getCampaignData } from '../../../utilities/investment-process/useCampaign'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
const store = useInvestmentProcessDataState()
const { acceptedRisks } = storeToRefs(store)

withDefaults(
    defineProps<{
        showAcceptAllRisks: boolean
    }>(),
    {
        showAcceptAllRisks: false,
    }
)

const acceptAllRisks = computed({
    get() {
        return [...getCampaignData().disclaimers].every((disclaimer) => acceptedRisks.value.includes(disclaimer))
    },
    set(newValue) {
        if (newValue === true) {
            acceptedRisks.value = [...getCampaignData().disclaimers]
        }
    },
})

function isAcceptedDisclaimer(disclaimer) {
    return !!acceptedRisks.value.find((acceptedRisk) => acceptedRisk.id === disclaimer.id)
}

function setDisclaimerConsent(disclaimerId, value) {
    if (value === true) {
        acceptedRisks.value.push(getCampaignData().disclaimers.find((disclaimer) => disclaimer.id === disclaimerId))
    } else {
        acceptedRisks.value = acceptedRisks.value.filter((disclaimer) => disclaimer.id !== disclaimerId)
    }
}
</script>

<template>
    <fieldset>
        <h1 class="my-5 border-b pb-3 pt-4 text-2xl font-bold text-gray-700">
            {{ $t('investment_process.disclaimers') }}
        </h1>
        <div>
            <div v-if="showAcceptAllRisks" class="relative flex items-start">
                <div class="flex h-6 items-center">
                    <input
                        id="understand_and_accept_all_risks"
                        v-model="acceptAllRisks"
                        aria-describedby="comments-description"
                        name="understand_and_accept_all_risks"
                        type="checkbox"
                        class="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" />
                </div>
                <div class="ml-3 min-w-0 flex-1 text-sm leading-6">
                    <label for="understand_and_accept_all_risks" class="font-semibold text-gray-900">{{
                        $t('investment_process.understand_all_risks')
                    }}</label>
                </div>
            </div>
            <div
                v-for="disclaimer in getCampaignData().disclaimers"
                :key="disclaimer.id"
                class="relative flex items-start">
                <div class="flex h-6 items-center">
                    <input
                        :id="'document_' + disclaimer.id"
                        :aria-describedby="'document-description_' + disclaimer.id"
                        :name="'document_' + disclaimer.id"
                        type="checkbox"
                        class="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
                        :checked="isAcceptedDisclaimer(disclaimer)"
                        @change="(event) => setDisclaimerConsent(disclaimer.id, event.target.checked)" />
                </div>
                <div class="ml-3 min-w-0 flex-1 text-sm leading-6">
                    <label :for="'document_' + disclaimer.id" class="font-medium font-semibold text-gray-900">{{
                        disclaimer.risk_title
                    }}</label>
                    <div
                        :id="'document-description_' + disclaimer.id"
                        class="break-words text-gray-500"
                        v-html="disclaimer.risk_content"></div>
                </div>
            </div>
        </div>
    </fieldset>
</template>

<style scoped></style>
